import { createSelector } from '@ngrx/store';
import { FieldState, OptionState } from '../../../../../models';
import { createFieldRelatedCheckedOptionsSelector } from '../create-field-related-checked-options/create-field-related-checked-options.selector';
import { createFieldStateSelector } from '../create-field-state-selector/create-field-state.selector';
import { CreateFilteredDataIdsSelector } from '../create-filtered-data-ids-selector/create-filtered-data-ids.selector';

/**
 * Returns Set<string> of nested data ids for checked options. If there is no checked options, returns null.
 * @param filterInstanceId 
 * @param fieldId 
 * @returns 
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createFieldRelatedNestedDataIdsSelector = (filterInstanceId: string, fieldId: string) =>
  createSelector(
    CreateFilteredDataIdsSelector(filterInstanceId),
    createFieldStateSelector(filterInstanceId, fieldId),
    createFieldRelatedCheckedOptionsSelector(filterInstanceId, fieldId),
    (filteredDataIds: string[], currentField: FieldState, checkedOptions: OptionState[]) => {
      if (!currentField) {
        return new Set<string>();
      }

      if (checkedOptions.length) {
        const filteredDataIdsSet = new Set<string>(filteredDataIds);
        const nestedIds = checkedOptions.flatMap((optionState) =>
          Object.keys(optionState.relatedDataInfo)
            .filter((key) => filteredDataIdsSet.has(key))
            .flatMap((key) => optionState.relatedDataInfo[key].nestedIds)
        );
        return new Set<string>(nestedIds);
      }

      return null;
    }
  );
